import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="w-full bg-bg-primary pt-12 md:pt-20 pb-16 md:pb-24 px-4" data-id="element-143">
      <div className="max-w-7xl mx-auto" data-id="element-144">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-145">
          {/* Mobile: Image first */}
          <div className="lg:hidden" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/9e5aqW53oEvCc8HSyPBvDP/emprende_USA_Express2.png" alt="EMPRENDE USA EXPRESS - La Guía Maestra" className="w-full max-w-xs mx-auto" data-id="element-147" />
          </div>

          {/* Text Content */}
          <div className="space-y-6 md:space-y-8" data-id="element-148">
            <div className="space-y-4 md:space-y-6" data-id="element-149">
              <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold leading-tight" data-id="element-150">
                Domina tu empresa en Estados Unidos
              </h1>
              <p className="text-base md:text-xl lg:text-2xl text-text-secondary leading-relaxed" data-id="element-151">
                El sistema completo basado en 4 pilares fundamentales para
                registrar, estructurar y operar tu empresa correctamente desde
                el primer día.
              </p>
            </div>

            <CTAButton className="max-w-xl" showPrice={false} data-id="element-152" />

            <div className="flex flex-wrap gap-4 md:gap-6 text-xs md:text-sm text-text-secondary pt-2 md:pt-4" data-id="element-153">
              <div className="flex items-center gap-2" data-id="element-154">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-cta" fill="currentColor" viewBox="0 0 20 20" data-id="element-155">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-156" />
                </svg>
                <span data-id="element-157">Sistema paso a paso</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-158">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-cta" fill="currentColor" viewBox="0 0 20 20" data-id="element-159">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-160" />
                </svg>
                <span data-id="element-161">Descarga inmediata</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-162">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-cta" fill="currentColor" viewBox="0 0 20 20" data-id="element-163">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-164" />
                </svg>
                <span data-id="element-165">Formato PDF</span>
              </div>
            </div>
          </div>

          {/* Desktop: Image on right */}
          <div className="hidden lg:block" data-id="element-166">
            <img src="https://cdn.magicpatterns.com/uploads/9e5aqW53oEvCc8HSyPBvDP/emprende_USA_Express2.png" alt="EMPRENDE USA EXPRESS - La Guía Maestra" className="w-full max-w-lg mx-auto" data-id="element-167" />
          </div>
        </div>
      </div>
    </section>;
}